<template>
  <click-to-edit
    v-model="scope.row.scale.weight"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.weight')"
    placeholder=""
    digits-only
    @input="saveElementPropChange(scope.row, 'scale', {weight:$event})"
  >
  </click-to-edit>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-weight-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],
  props: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style>

</style>